import ActionItemRegistry from './registry';
import session from '../../framework/utils/session-store';
import store from '../../store';
import { romeApi, toastService } from '../../framework';
import {sendPlanDocService} from './send-plan-doc-service.js';

ActionItemRegistry.register({
  itemType: ["ewf-send-plan-docs"],
  buttons: (actionItem) =>
      [{
        text: "Done", 
        click: () => sendPlanDocService.onComplete(actionItem),
        css: session.state.user.isInternalUser ? "btn-success" : "btn-none",
      }],
      links: (actionItem) => [{ text: "Upload Plan Document", href: `/employer/${actionItem.entityId}/plans/documents` }]
});

ActionItemRegistry.register({
  itemType: ["custom-amended-plan-docs"],
  buttons: (actionItem) =>
      [{
        text: "Done", 
        click: () => sendPlanDocService.completeAmended(actionItem),
        css: session.state.user.isInternalUser ? "btn-success" : "btn-none",
      }],
      links: (actionItem) => [{ text: "Upload Plan Document", href: `/employer/${actionItem.entityId}/plans/documents` }]
});

ActionItemRegistry.register({
  itemType: ["ewf-send-sbc-docs"],
  buttons: (actionItem) =>
      [{
        text: "Done",
        click: () => sendPlanDocService.onComplete(actionItem),
        css: session.state.user.isInternalUser ? "btn-success" : "btn-none",
      }],
      links: (actionItem) => [{ text: "Upload Hra Sbc Document", href: `/employer/${actionItem.entityId}/plans/documents` }]
});

ActionItemRegistry.register({
  itemType: ["ewf-review-configuration"]
});

ActionItemRegistry.register({
    itemType: ["ewf-review-changed-services"],
    buttons: "Done",
    links: (actionItem) => [
      { text: null, href: `/employer/${actionItem.entityId}/history?tags=32&fromDate=${moment().add(-1, 'years').format('MM-DD-YYYY')}&toDate=${moment().add(1, 'days').format('MM-DD-YYYY')}` },
      { text: "Open Order", href: `/employer/${actionItem.entityId}/order?workflowId=${actionItem.workflowId}` }
      ]
})

ActionItemRegistry.register({
    itemType: ["ewf-broker-handoff"],
    buttons: "Done",
    links: (actionItem) => [{ text: "Open Contract", href: `/employer/${actionItem.entityId}/order?workflowId=${actionItem.workflowId}` }]
})

ActionItemRegistry.register({
    itemType: ["ewf-new-employer-accept-tc", "ewf-renewal-accept-tc"],
    buttons: "none",
    links: (actionItem) => {
      const reminderType = actionItem.itemType.replace('ewf-', '');

      const items = [
        {
          text: null,
          href: `/employer/${actionItem.entityId}/order?workflowId=${actionItem.workflowId}`
        }];

      if (session.state.user.isInternalUser) {
        items.push({ text: "Send Reminder Email",
          click: async () => {
            await romeApi.post(`/workflow/${actionItem.workflowId}/email/reminder?messageType=${reminderType}`);
            toastService.success("Reminder email has been sent successfully");
          }
        })
      }

      return items;
    }
})

ActionItemRegistry.register({
    itemType: ["ewf-configure-calendars"],
    buttons: "Done",
    links: async (actionItem) => {
      let wfOrder = await romeApi.get(`workflow/${actionItem.workflowId}/order`);

      if (wfOrder.orderEffectiveDate) {
        let date = moment(wfOrder.orderEffectiveDate).format('MM-DD-YYYY');
        return [{ text: "Open calendars" , href: `/employer/${actionItem.entityId}/calendars?orderEffectiveDate=${date}` }];
      }

      return [{ text: "Open calendars" , href: `/employer/${actionItem.entityId}/calendars` }];
    },
});

ActionItemRegistry.register({
    itemType: ["ewf-configure-plans"],
    buttons: "Done",
    links: (actionItem) => {
      const links = [];

      links.push({ text: null, href: `/employer/${actionItem.entityId}/plans?planId=future` });

      if (actionItem.plansToConfigure) {
        actionItem.plansToConfigure.map(plan => {
          links.push({ text: `Configure ${plan.name}`, href: `/employer/${actionItem.entityId}/plans?planId=${plan.id}`})
        })
      }

      return links;
    },
});

ActionItemRegistry.register({
  itemType: ["ewf-complete-portal-enrollments"],
  buttons: "Done",
  links: (actionItem) => {
    const links = [];
    links.push({text: 'Click here to add new participants ', href: `/employer/${actionItem.entityId}/participants`});
    links.push({text: 'Click here to enroll participants into accounts. Use this for all existing participants and any newly created participants', href: `/employer/${actionItem.entityId}/accounts`});
    return links;
  },
});

ActionItemRegistry.register({
    itemType: ["ewf-configure-banking"],
    buttons: "Done",
    links: (actionItem) => [{ text: "Open banking information" , href: `/employer/${actionItem.entityId}/banking` }],
});

ActionItemRegistry.register({
  itemType: ["ewf-finance"],
  buttons: "Done",
  links: (actionItem) => [{ text: "", href: `/employer/${actionItem.entityId}/general` }],
  values: (actionItem) => [{
    name: "Order Eff. Date", value: actionItem.orderEffectiveDate ? moment(actionItem.orderEffectiveDate).format("MM-DD-YYYY") : "See Order Form"
  }]
});

ActionItemRegistry.register({
  itemType: ["ewf-finance-renewal"],
  buttons: "Done",
  links: (actionItem) => [{ text: "History", href: `/employer/${actionItem.entityId}/history?tags=Finance,Services&fromDate=${moment().add(-1, 'years').format('MM-DD-YYYY')}&toDate=${moment().add(1, 'days').format('MM-DD-YYYY')}` }],
  values: (actionItem) => [{
    name: "Order Eff. Date", value: actionItem.orderEffectiveDate ? moment(actionItem.orderEffectiveDate).format("MM-DD-YYYY") : "See Order Form"
  }]
});

ActionItemRegistry.register({
  itemType: ["ewf-process-spreadsheet"],
  component: "ProcessSpreadsheetEnrollments",
  buttons: "Done"
});

ActionItemRegistry.register({
    itemType: ["ewf-review-spreadsheet"],
    component: "ReviewSpreadsheetEnrollments",
    buttons: "Done"
});

ActionItemRegistry.register({
  itemType: ["ewf-configure-cobra"],  
  component: "CobraSetupLink",
  buttons: "none"
});

ActionItemRegistry.register({
    itemType: [
        "ewf-configure-cobra-rates",
        "ewf-import-cobra-rates",
        "ewf-reach-out-call-cobra",
        "ewf-send-cobra-rates-verification",
        "ewf-review-cobra-rates"
    ],
    buttons: "Done",
    links: (actionItem) => [{ text: "Open Contract", href: `/employer/${actionItem.entityId}/employer-cobra` }]
});

ActionItemRegistry.register({
  itemType: ["ewf-wca-build-plans"],
  component: "WcaBuildPlans",
  buttons: "Done"
});

ActionItemRegistry.register({
    itemType: ["ewf-qa-employer-configuration"],
    buttons: "Done"
});

ActionItemRegistry.register({
    itemType: ["ewf-wca-qa-employer-configuration"],
    buttons: "Done"
});

ActionItemRegistry.register({
    itemType: ["ewf-qa-enrollments"],
    component: "QaEnrollments",
    buttons: "Done"
});

ActionItemRegistry.register({
    itemType: ["ewf-qa-cobra-rates"],
    buttons: "Done",
    links: (actionItem) => [{ href: `/employer/${actionItem.entityId}/employer-cobra` }]
});

ActionItemRegistry.register({
  itemType: [
    "ewf-termination-finalize",
    "ewf-termination-finalize-v2",
    "ewf-termination-finance",
    "ewf-termination-ops-review",
    "ewf-termination-qa",
    "termination-cancelled"
  ],
  component: "TerminationActionItem",
});

ActionItemRegistry.register({
  itemType: ["ewf-setup-online-enrollments"],
  component: "SetUpOnlineEnrollments",
  buttons: "none",
});

ActionItemRegistry.register({
  itemType: ["ewf-termination-retain-business","ewf-termination-retain-business-v2"],
  component: "TerminationActionItem",
  buttons: (actionItem) => [{
      text: "Retained",
      css: 'btn-success',
      click: async () => {
        let features = store.state.session.features;
        if (features && features.includes("non-workflow-termination")) {
          await romeApi.post(`/employer/${actionItem.employerId}/termination/${actionItem.actionItemId}/retained`, {
            terminationId: actionItem.terminationId,
            notes: 'Business was retained, cancelling termination'
          });
        }
        else {
          await romeApi.post(`/actionitem/v-2/${actionItem.actionItemId}/reject`, {
            notes: 'Business was retained, cancelling termination workflow'
          });
        }
        store.dispatch('actionItems/refresh');
        toastService.success('Business was retained, termination cancelled', 'Business Retained')
      },
    }, {
      text: "Lost",
      css: 'btn-danger',
      click: async () => {
        if (!(await modalService.confirm('Are you sure?'))) return;
        await romeApi.post(`/employer/${actionItem.employerId}/termination/${actionItem.actionItemId}/lost`, {
          employerId: actionItem.employerId,
        });
        store.dispatch('actionItems/refresh');
        toastService.info('Action item has been completed');
      },
    }]

})

ActionItemRegistry.register({
  itemType: "ewf-termination-form-review",
  component: "TerminationFormReview"
})

ActionItemRegistry.register({
  itemType:[
    "ewf-setup-edi",
    "ewf-review-edi"
  ],
  buttons: "Done",
  links: async (actionItem) => {

    let edi = await romeApi.get(`employer/${actionItem.entityId}/edi`);

    if(!edi.isEdiClient){
      await romeApi.post(`employer/${actionItem.entityId}/edi`, { isEdiClient: true })
    }

    return [{ text: "Open EDI Settings", href: `/employer/${actionItem.entityId}/edi` }];
  }
});

ActionItemRegistry.register({
  itemType: ['reactivated-plan'],
  values: (item) => [{ name: 'Plan', value: item.plan }]
});

ActionItemRegistry.register({
  itemType: ['termination-dates-updated'],
  links: async (actionItem) => [{ name: 'History', href: `/employer/${actionItem.entityId}/history` }]
});

ActionItemRegistry.register({
  itemType: ['files-uploaded'],
  component: "FilesUploaded",
  buttons: "Done",
});



// WEBPACK FOOTER //
// ./src/action-items/types/workflow-items.js